import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sd-loader',
  template: '',
  styleUrls: ['./sd-loader.component.scss']
})
export class SdLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
